export const readableDate = dateString => new Date(dateString).toDateString()